// Liste des sprites ennemis spécifiques disponibles (fichiers présents dans /public/sprites/enemies/).
// Si un ID n'est pas ici, on retombe sur l'emoji de l'ennemi.
export const HAS_ENEMY_SPRITE = new Set([
  // Normaux
  "araignee",
  "elementaire_air",
  "elementaire_feu",
  "gobelin",
  "slime",
  "squelette",
  "chauvesouris",
  "fee",
  "rat_geant",
  "loup",
  "champignon",
  "serpent",
  "corbeau",
  "zombie",
  "crapaud",
  "golem_pierre",
  "spectre",
  "meduse",
  "scorpion",
  "golem_glace",
  "flamme_follette",
  "harpie",
  "ver_des_sables",
  "piranha_essaim",
  "cristal_vivant",
  "esprit_feu",
  "mante",
  // Élites
  "mage_noir",
  "ondine",
  "orc",
  "troll",
  "gargouille",
  "chevalier_noir",
  "golem_lave",
  "chimere",
  "wyverne",
  "banshee",
  "naga",
  "golem_cristal",
  // Boss
  "minotaure",
  "lich",
  "leviathan",
  "dragon",
  "archange",
  "cerbere",
  "kraken",
  "golem_titan",
  "phenix",
  "demon",
  "golem_tempete",
  "hydre",
  "golem_abysses",
  "seraphin",
  "titan_ancien",
]);

export const enemySpriteUrl = (id) => HAS_ENEMY_SPRITE.has(id) ? `/sprites/enemies/${id}.png` : null;

// Les sprites d'ennemis ont été RÉGÉNÉRÉS (image-to-image) pour être orientés vers la GAUCHE,
// c.-à-d. face au joueur (qui est à gauche en combat). On ne retourne donc plus les sprites par défaut.
// Exception : quelques créatures très symétriques (ex : la mante) que la régénération n'a pas réussi
// à réorienter et qui regardent encore à DROITE → on les retourne ici (mirroir horizontal, gratuit).
// TODO: ajouter à cette liste tout ennemi qui regarderait encore dans le mauvais sens.
const ENEMY_FACES_RIGHT = new Set([
  "mante",
  // Signalés par l'utilisateur comme regardant encore à droite après régénération :
  "archange", "chimere", "cerbere", "rat_geant", "golem_titan",
  "mage_noir", "zombie", "golem_lave",
  "golem_glace", "golem_pierre", "leviathan", "harpie", "ondine",
]);

// true → il faut retourner le sprite horizontalement pour qu'il regarde le joueur (à gauche).
export const enemyFlipToFacePlayer = (id) => ENEMY_FACES_RIGHT.has(id);

